import { useCallback } from 'react';
import { NgapAct } from '../types/ngap';
import { useToast } from './useToast';
import { trackSimulatorActAdded, trackSimulatorActRemoved } from '../utils/analyticsEvents';
import { useAppContext } from '../store';

interface UseCartReturn {
  handleToggleCartItem: (act: NgapAct) => void;
}

export const useCart = (): UseCartReturn => {
  const { state, dispatch } = useAppContext();
  const { cartItems } = state.searchAndFilter;
  const { success } = useToast();

  const handleToggleCartItem = useCallback((act: NgapAct) => {
    const isCurrentlyInCart = cartItems.some(item => item.act.ID === act.ID);
    
    // Toggle cart item in global state
    dispatch({ type: 'TOGGLE_CART_ITEM', payload: act });
    
    // Show toast
    if (isCurrentlyInCart) {
      success(
        'Retiré du panier',
        `${act.lettre_cle || ''} a été retiré de votre panier`
      );
    } else {
      success(
        'Ajouté au panier',
        `${act.lettre_cle || ''} a été ajouté à votre panier`
      );
    }

    // Track cart action
    const libelle = act.libelle || act.lettre_cle || 'unknown';
    if (isCurrentlyInCart) {
      trackSimulatorActRemoved(libelle);
    } else {
      trackSimulatorActAdded(libelle);
    }
  }, [cartItems, success, dispatch]);

  return {
    handleToggleCartItem
  };
};